import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefer = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 12,
	viewBox: "0 0 20 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 6C5.20435 6 4.44129 5.68393 3.87868 5.12132C3.31607 4.55871 3 3.79565 3 3C3 2.20435 3.31607 1.44129 3.87868 0.87868C4.44129 0.316071 5.20435 0 6 0C6.79565 0 7.55871 0.316071 8.12132 0.87868C8.68393 1.44129 9 2.20435 9 3C9 3.79565 8.68393 4.55871 8.12132 5.12132C7.55871 5.68393 6.79565 6 6 6ZM14 6C13.2044 6 12.4413 5.68393 11.8787 5.12132C11.3161 4.55871 11 3.79565 11 3C11 2.20435 11.3161 1.44129 11.8787 0.87868C12.4413 0.316071 13.2044 0 14 0C14.7956 0 15.5587 0.316071 16.1213 0.87868C16.6839 1.44129 17 2.20435 17 3C17 3.79565 16.6839 4.55871 16.1213 5.12132C15.5587 5.68393 14.7956 6 14 6ZM6 8C7.13517 7.99865 8.25757 8.23951 9.29224 8.70649C10.3269 9.17348 11.25 9.85583 12 10.708V12H0V10.708C0.749953 9.85583 1.67309 9.17348 2.70776 8.70649C3.74243 8.23951 4.86483 7.99865 6 8ZM14 12V9.952L13.5 9.385C13.1183 8.95221 12.7001 8.55307 12.25 8.192C12.8245 8.06404 13.4114 7.99965 14 8C15.1352 7.99865 16.2576 8.23951 17.2922 8.70649C18.3269 9.17348 19.25 9.85583 20 10.708V12H14Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgRefer);
export { ForwardRef as ReactComponent };
